import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src1154976400/src/nuxt/layouts/default.vue").then(m => m.default || m))
}